$(document).ready(function() {
  jQuery('.slickslider').slick({
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    arrows: true,
    speed: 500,
    slide: 'div',
    cssEase: 'linear',
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
});

/* Envision - Geolocation Redirect & Modal */

function getGeolocation() {
  return fetch("https://get.geojs.io/v1/ip/geo.json").then(response => response.json());
}

function makeGeolocationModal(geolocationModal, geolocationData, countryAdjContent, possAdjContent, URL) {
  const countryWrappers = geolocationModal.find(".geolocation-modal__country");
  const countryAdjectiveWrappers = geolocationModal.find(".geolocation-modal__country-adjective");
  const possAdjWrappers = geolocationModal.find(".geolocation-modal__poss-adj");
  const domainWrappers = geolocationModal.find(".geolocation-modal__domain");
  const country = geolocationData.country;
  const initGeolocationModal = geolocationModal.remodal();
  let hostUTM = "usa";
  countryWrappers.text(country);
  countryAdjectiveWrappers.text(countryAdjContent || country);
  possAdjWrappers.text(possAdjContent);
  domainWrappers.text(URL);
  domainWrappers.attr("href", `https://${URL}/?utm_source=gel-blaster-${hostUTM}&utm_medium=popup&utm_campaign=geo-redirect`);
  initGeolocationModal.open();
  $(document).on('confirmation', '.remodal', function () {
    window.location.href = domainWrappers.attr("href");
  });
}

if (!Shopify.designMode) {
  $(document).ready(function() {
    getGeolocation().then(geolocationData => {
      const countryCode = geolocationData.country_code;
      const continentCode = geolocationData.continent_code;
      const nordicCountryCodes = ["DK", "FI", "NO", "SE", "IS"];
      const redirectableLocations = {
        /*
        "DK": "https://linktr.ee/gelblasterdk",
        "FI": "https://www.gigantti.fi/brand/gel-blaster",
        "NO": "https://www.elkjop.no/brand/gel-blaster",
        "SE": "https://www.elgiganten.se/brand/gel-blaster",
        */
        "KR": "https://gelblaster.cafe24.com/"
      };
      if (Object.keys(redirectableLocations).includes(countryCode)) {
        window.location.href = redirectableLocations[countryCode];
      } else if (continentCode === "EU" && !nordicCountryCodes.includes(countryCode)) {
        window.location.href = "https://gelblaster.co.uk";
      } else if (countryCode === "ZA") {
        const geolocationModal = $('[data-remodal-id="geolocationModal"]');
        makeGeolocationModal(geolocationModal, geolocationData, "South African", "our South African site: ", "thegelblaster.co.za");
      }
    });
  });
}
